import { Box, Stack } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { BrandLogo } from '~portal/components/BrandLogo';
import { Cmp } from '~portal/lib';
import { AccountBlock } from './AccountBlock';
import * as styles from './GlobalNav.css';
import { GlobalNavItems } from './GlobalNavItems';
import { NavSettings } from './NavSettings';

/**
 * @desc The platform's desktop global navigation: a full-height column left of every non-chat
 * page — logo (home), the five section pills, then the settings row and the account block
 * pinned to the bottom. Below `md` it is replaced by `GlobalNavMobileHeader` + `GlobalNavDrawer`,
 * which render the same items.
 */
export const GlobalNav: Cmp = function () {
  return (
    <Box component="nav" aria-label="Main" visibleFrom="md" className={styles.column}>
      <Link to="/" aria-label="H2GC home" className={styles.logoLink}>
        <BrandLogo height={70} />
      </Link>
      {/* The frames start the first pill at y≈190, ~72px below the logo's foot. */}
      <Box mt={72}>
        <GlobalNavItems />
      </Box>
      <Stack gap="sm" mt="auto" pt="lg">
        <NavSettings />
        <AccountBlock />
      </Stack>
    </Box>
  );
};
